import { render, staticRenderFns } from "./thanks-letter-2020.vue?vue&type=template&id=5b518aad&scoped=true&"
import script from "./thanks-letter-2020.vue?vue&type=script&lang=js&"
export * from "./thanks-letter-2020.vue?vue&type=script&lang=js&"
import style0 from "./thanks-letter-2020.vue?vue&type=style&index=0&id=5b518aad&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b518aad",
  null
  
)

export default component.exports